import {Component} from 'react';

import {gettext} from 'topmeteo/utils/i18n';

import Basket from './Basket';

const TodayLabel = gettext('Today');

class ShoppingBasket extends Component {

    constructor(props) {
        super(props);

        const {
            formatCurrency,
            expiration_date: expirationDate,
            start_date: startDate,
            ...initialData
        } = props;

        this.formatCurrency = formatCurrency;

        this.state = {
            expirationDate,
            startDate,
            ...initialData,
        };
    }

    render() {
        const {AOPACode} = this.props;

        return (
            <Basket
                {...this.state}
                AOPACode={AOPACode}
                formatCurrency={this.formatCurrency}
            />
        );
    }

    setRegion(region) {
        this.setState({region});
    }

    setDiscount(discount) {
        this.setState({discount});
    }

    setDuration(duration) {
        this.setState(state => ({
            packet: {...state.packet, price: duration.price},
            duration: {...duration, price: null},
        }));
    }

    setStartDate(date) {
        const value = date instanceof Date ? date : new Date(date);

        /* check for valid date */
        if (Number.isNaN(value.getTime())) return false;

        const now = new Date();
        const localDateString = value.toLocaleDateString();
        const isToday = now.toLocaleDateString() === localDateString;
        const startDate = {price: null, label: isToday ? TodayLabel : localDateString, value};

        return this.setState({startDate});
    }

    toggleOption(option, selected) {
        this.setState(({options}) => ({
            options: selected ? [...options, option] : options.filter(({value}) => value !== option.value),
        }));
    }

}

export default ShoppingBasket;
